/**
 * Show a loader inside a given element
 * @param {HTMLElement} $target - Element to add loader to. Pass body to block the whole page.
 */
function addLoader($target) {
    $target.each(function setLoadingClass() {
        if ($(this).hasClass('loading')) return;

        const $tempDiv = [
            '<div class="loader temp-loader" style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;">',
            '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="411.2 452.8 201.6 118.41">',
            '<title />',
            '<path fill="none" stroke="#fe6f00" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" stroke-width="9.6" d="M511.314 499.191h40.9v-29.592c0-0.007 0-0.016 0-0.025 0-1.644 0.324-3.214 0.91-4.647l-0.030 0.082c0.613-1.511 1.466-2.804 2.524-3.896l-0.004 0.004c1.050-1.084 2.305-1.961 3.704-2.572l0.075-0.029c1.315-0.577 2.848-0.913 4.459-0.914h1.655c3.088 0.004 6.048 1.267 8.23 3.514s3.408 5.293 3.408 8.471v9.244h10.718c2.618 0 5.13 1.070 6.981 2.976s2.891 4.489 2.891 7.182v10.158c2.724 0.004 5.336 1.118 7.261 3.101s3.006 4.672 3.006 7.474l-0.006 4.56c0 2.802-1.082 5.492-3.006 7.474s-4.537 3.098-7.261 3.101v10.158c0 2.694-1.040 5.278-2.891 7.182s-4.363 2.976-6.981 2.976h-10.717v9.244c0 3.177-1.226 6.224-3.408 8.471s-5.142 3.511-8.23 3.514h-1.657c-1.53 0-3.045-0.31-4.458-0.914-1.473-0.64-2.728-1.518-3.775-2.599l-0.004-0.004c-1.055-1.089-1.908-2.382-2.493-3.813l-0.029-0.080c-0.557-1.351-0.88-2.92-0.88-4.565 0-0.009 0-0.018 0-0.026v0.001-29.592h-76.971v29.605c0 0.005 0 0.011 0 0.015 0 1.646-0.324 3.217-0.912 4.652l0.030-0.082c-0.614 1.509-1.467 2.801-2.525 3.892l0.004-0.004c-1.050 1.082-2.304 1.959-3.702 2.569l-0.075 0.029c-1.314 0.576-2.845 0.912-4.458 0.913h-1.645c-1.531 0-3.047-0.31-4.462-0.914-1.474-0.641-2.731-1.519-3.778-2.602l-0.004-0.004c-1.055-1.090-1.908-2.384-2.493-3.817l-0.029-0.080c-0.555-1.349-0.876-2.913-0.876-4.555 0-0.013 0-0.027 0-0.040v0.002-9.243h-10.728c-2.618 0-5.13-1.070-6.981-2.976s-2.892-4.489-2.892-7.182v-10.158h-3.433c-2.726 0-5.342-1.114-7.268-3.098s-3.010-4.673-3.010-7.478l0.006-4.515c0-2.806 1.083-5.494 3.010-7.478s4.542-3.098 7.267-3.098h3.434v-10.158c0-2.694 1.040-5.278 2.891-7.182s4.363-2.976 6.981-2.976h10.728v-9.243c0-0.011 0-0.023 0-0.036 0-1.641 0.322-3.208 0.906-4.639l-0.030 0.082c0.613-1.512 1.466-2.806 2.524-3.899l-0.004 0.004c1.050-1.084 2.305-1.964 3.704-2.576l0.075-0.029c1.315-0.578 2.849-0.914 4.461-0.914h1.646c1.53 0 3.044 0.31 4.456 0.913 1.473 0.639 2.728 1.516 3.775 2.595l0.004 0.004c1.055 1.088 1.908 2.379 2.493 3.809l0.029 0.080c0.559 1.353 0.883 2.925 0.883 4.572 0 0.005 0 0.009 0 0.014v-0.001 29.605h35.864" />',
            '</svg>',
            '</div>',
        ].join('');

        $(this).append($tempDiv);
        $(this).addClass('loading');
    });
}

/**
 * Remove existing loader
 * @param {HTMLElement} $loader - jQuery pointer to the loader element
 */
function removeLoader($loader) {
    if (!$loader.length && $('body').hasClass('loading')) {
        $('body').removeClass('loading');
        $('body').find('temp-loader').remove();
        return;
    }

    if ($loader.find('.temp-loader').length) {
        $loader.find('.temp-loader').remove();
        $loader.removeClass('loading');
        return;
    }
}

// element-level loader
$.fn.loader = function loaderFn() {
    const $element = $(this);

    const LoaderFn = function LoaderFn() {
        this.start = function start() {
            if ($element.length) {
                addLoader($element);
            }
        };

        this.stop = function stop() {
            if ($element.length) {
                const $loader = $('.loading');
                removeLoader($loader);
            }
        };
    };

    return new LoaderFn();
};

// page-level loader
$.loader = function pageLoaderFn() {
    const PageLoaderFn = function PageLoaderFn() {
        this.start = function start() {
            addLoader($('body'));
        };

        this.stop = function stop() {
            removeLoader($('.loading'));
        };
    };

    return new PageLoaderFn();
};

